export default __webpack_public_path__ + "e8eadb87c6fe00fdee9d6a9b77643db0.png";